import { Sector } from '@umanforge/common';
import { PostSector } from '../interfaces/api_sector.interfaces';

export const DEFAULT_POST_SECTOR: PostSector = { siteId: '', name: '', users: [], admins: [] };
export const getCreateSector: ( t: ( str: string ) => string  ) => Sector = t => {
  return { ...DEFAULT_POST_SECTOR, id: 'new_sector', name: t( 'Create new sector' ), isAdmin: undefined };
};